import { AxiosInstance } from '../../service/axios-instance';

export interface AuditEvent {
  _id?: string;
  timestamp?: string;
  action?: string;
  api_cmd?: string;
  api_method?: string;
  api_path?: string;
  tenant?: string;
  actor?: string;
  ip?: string;
  payload?: any;
  before?: any;
  after?: any;
}

export interface AuditHistoryFilters {
  actor?: string;
  action?: string;
  api_cmd?: string;
  api_method?: string;
}

function compactParams(params: Record<string, string | number | undefined>) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && String(value).trim() !== '')
  );
}

export async function listAuditHistory(db: string, limit = 200, filters: AuditHistoryFilters = {}): Promise<AuditEvent[]> {
  const res = await AxiosInstance.get('/audit/history', {
    params: compactParams({ db, limit, ...filters }),
    withCredentials: true,
  });
  return res.data;
}
